




















































import { Component, Vue, Ref, Prop, Provide } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import { ALL_PAYCHECK_PERIODS_FOR_PAYCHECK_LIST } from '@/queries/PaycheckPeriod';
import { GQL_currentUnitPaycheckPeriods, GQL_currentUnitPaycheckPeriods_currentUnit_paycheckPeriods } from '@/queries/__generated__/currentUnitPaycheckPeriods';
import PaycheckDraftPeriodForm from '@/components/Paycheck/PaycheckDraftPeriodForm.vue';
import paycheckSettingsService from '@/utils/paycheck-settings-service';
import { UnsavedChanges } from '@/decorators/unsaved-changes';
import i18n from '@/i18n';
import BeforeChangeWrapper from '@/components/BeforeChangeWrapper.vue';
import unitPaycheckSettingsRequiredGuard from '@/guards/unit-paycheck-settings-required-guard';
import { periodYears } from '@/app/paycheck-period';
import { ALL_CARS } from '@/queries/Car';
import { ALL_PROJECTS } from '@/queries/Project';
import { ALL_DEPARTMENTS } from '@/queries/Department';
import { GQL_currentUnitCars, GQL_currentUnitCars_currentUnit_cars } from '@/queries/__generated__/currentUnitCars';
import { GQL_currentUnitProjects, GQL_currentUnitProjects_currentUnit_projects } from '@/queries/__generated__/currentUnitProjects';
import { GQL_currentUnitDepartments, GQL_currentUnitDepartments_currentUnit_departments } from '@/queries/__generated__/currentUnitDepartments';
import ProductForm from '@/components/Product/ProductForm.vue';

@Component({
  components: {
    PaycheckDraftPeriodForm,
    BeforeChangeWrapper,
  },
  beforeRouteEnter: (to, from, next) => {
    unitPaycheckSettingsRequiredGuard(to, from, next);
  },
})
export default class Paychecks extends Vue {
  @SmartQuery<Paychecks, GQL_currentUnitPaycheckPeriods>({
    query: ALL_PAYCHECK_PERIODS_FOR_PAYCHECK_LIST,
    update: data => data.currentUnit.paycheckPeriods
      .sort((p1, p2) => p1.endDate > p2.endDate ? -1 : 1), // sort descending
  }) private paycheckPeriods?: GQL_currentUnitPaycheckPeriods_currentUnit_paycheckPeriods[];

  @SmartQuery<ProductForm, GQL_currentUnitCars>({
    query: ALL_CARS,
    update: data => data.currentUnit.cars,
  }) public cars!: GQL_currentUnitCars_currentUnit_cars[];

  @SmartQuery<ProductForm, GQL_currentUnitProjects>({
    query: ALL_PROJECTS,
    update: data => data.currentUnit.projects,
  }) public projects!: GQL_currentUnitProjects_currentUnit_projects[];

  @SmartQuery<ProductForm, GQL_currentUnitDepartments>({
    query: ALL_DEPARTMENTS,
    update: data => data.currentUnit.departments,
  }) public departments!: GQL_currentUnitDepartments_currentUnit_departments[];

  @Prop({ type: Boolean, required: true })
  @Provide()
  private advancedPaycheckMode!: boolean;

  private paycheckSettingsService = paycheckSettingsService;
  private yearsForDropdown: number[] = [];

  private beforeMount() {
    paycheckSettingsService.checkExpandedSectionsExpiry();
  }

  private async created() {
    this.yearsForDropdown = await periodYears();
  }

  private closeAllOtherPeriods(key: string) {
    if (this.paycheckDraftPeriodForms) {
      for (const period of this.paycheckDraftPeriodForms) {
        if (period.$vnode.key !== key) {
          period.collapse();
        }
      }
    }
  }

  private get paycheckPeriodsForYear(): GQL_currentUnitPaycheckPeriods_currentUnit_paycheckPeriods[] {
    if (!this.paycheckPeriods) return [];

    return this.paycheckPeriods!.filter(p => this.$dayjs.strict(`${p.bookkeepingPeriod}-01`).year() === paycheckSettingsService.selectedYear);
  }

  // dirty

  @Ref() private paycheckDraftPeriodForms?: PaycheckDraftPeriodForm[];

  @UnsavedChanges<Paychecks>({
    messages: {
      entity: i18n.t('Paycheck.paychecks'),
    },
    saveAndContinue() {
      return this.saveAllDirty();
    },
  })
  private dirtyForms = false;

  private checkIfFormsAreDirty(): void {
    this.$nextTick(() => {
      if (!this.paycheckDraftPeriodForms) return;

      this.dirtyForms = this.paycheckDraftPeriodForms.some(form => form.formDirty);
    });
  }

  private saveAllDirty(): Promise<boolean> {
    if (!this.paycheckDraftPeriodForms) return new Promise(resolve => resolve(true));

    return new Promise((resolve) => {
      Promise.all(
        this.paycheckDraftPeriodForms!
          .filter(form => form.formDirty)
          .map(form => form.savePaycheckDrafts()),
      ).then(successes =>
        resolve(successes.every(success => success)),
      );
    });
  }

  private beforeYearChange(value: number, apply: Function, revert: Function): void {
    if (!this.dirtyForms) {
      apply();
      return;
    }

    this.$sPopup.alert(``, {
      title: this.$t('PaycheckDraft.beforeChangingYear'),
      message: this.$t('PopupBody.unsavedChanges', { entity: this.$t('Paycheck.paychecks'), action: this.$t('PaycheckDraft.changingYear') }),
      buttons: [
        {
          text: this.$t('PopupButton.yesSave'),
          color: 'primary',
          click: () => {
            this.saveAllDirty()
              .then(success => success ? apply() : revert());
          },
        },
        {
          text: this.$t('PopupButton.noDiscard'),
          click: () => apply(),
        },
      ],
      onCancel: () => revert(),
    });
  }
}
